import React, { Fragment, useRef } from 'react';
import { ComponentType, Container } from '@philips-internal/oswald-ui-core';
import { AbortableNavigateEvent, NavigateEvent } from '@philips-internal/oswald-ui-core/lib/component/types/index.js';
import { useSharedState } from '@philips-internal/oswald-ui-engine';
import { classNames, createAbort, getLostProps, isFunction } from '@philips-internal/oswald-ui-utils';
import { useTabStructure } from '../hooks/use-tab-structure.js';
import { SideTabs } from './side-tabs/side-tabs.js';
import { TabControlProperties } from './tab-control-types.js';
import './tab-control.css';
const TabControlContainer = {
    acceptedTypes: [
        ComponentType.NAVIGATION,
    ],
    name: '',
};
function TabControl(props) {
    const { children, defaultTab, onAfterNavigate, onNavigate, style = TabControlProperties.style.defaultValue, uuid = TabControlProperties.uuid.defaultValue, } = props;
    const [activeTab, setActiveTab] = useSharedState({
        initialValue: '',
        name: 'activeTab',
        props,
    });
    const [previousActiveTab, setPreviousActiveTab] = useSharedState({
        initialValue: '',
        name: 'previousActiveTab',
        props,
    });
    const tabContentRef = useRef(null);
    const showingTabsContainerRef = useRef(null);
    const navigate = (tabName) => {
        const abort = createAbort();
        if (isFunction(onNavigate)) {
            onNavigate(new AbortableNavigateEvent({ abort, from: activeTab, to: tabName }));
        }
        void abort.promise.then(aborted => {
            if (aborted) {
                return;
            }
            setPreviousActiveTab(activeTab);
            setActiveTab(tabName);
        });
    };
    const onTabClick = ({ value }) => {
        navigate(value);
    };
    const onNavigateTo = () => {
        if (!isFunction(onAfterNavigate)) {
            return;
        }
        if (isFunction(onAfterNavigate)) {
            onAfterNavigate(new NavigateEvent({ from: previousActiveTab, to: activeTab }));
        }
    };
    const lostProps = getLostProps(TabControlProperties, props);
    const { header, side } = useTabStructure({
        activeTab: activeTab || defaultTab,
        children,
        lostProps,
        onNavigateTo,
        onTabClick,
        showingTabsContainerRef,
        style,
        tabContentRef,
    });
    const className = classNames({
        'c-tab-control': true,
        [`${props.className}`]: Boolean(props.className),
    });
    return (React.createElement(Fragment, null,
        React.createElement(Container, { acceptedTypes: TabControlContainer.acceptedTypes, className: className, uuid: uuid },
            React.createElement("div", { className: "c-tab-control__header" },
                React.createElement("div", { className: "c-tab-control__showing-tabs", ref: showingTabsContainerRef }, header),
                React.createElement(SideTabs, { onItemClick: onTabClick, tabs: side }))),
        React.createElement("div", { className: "c-tab-control__content", ref: tabContentRef })));
}
export { TabControl, TabControlContainer, };
//# sourceMappingURL=tab-control.js.map